import { render, staticRenderFns } from "./ImageCanvasAnnotations.vue?vue&type=template&id=2997230b&lang=pug&"
import script from "./ImageCanvasAnnotations.vue?vue&type=script&lang=ts&"
export * from "./ImageCanvasAnnotations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports